export default function handleFormatCEP(cepNumber: string): string {
  return `${cepNumber.substr(0, 5)}-${cepNumber.substr(5, 3)}`;
}
